import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import "../../assets/css/modalStyle.css"
export default function ModalCustomized({ isOpen, toggle, title, children, btnAction, onClickBtnAction, btnActionColor, btnClose = false, className, size = "sm", fullscreen = "md", widthPadrao = true }) {
    return (
        <Modal 
        isOpen={isOpen} 
        toggle={toggle} 
        className={widthPadrao ? "modalStyle " + className : className} 
        fullscreen={fullscreen}
        size={size}
        >
            <ModalHeader className='modalHeader'>
                <span>{title}</span>
                {
                    btnClose
                        ? <Button onClick={toggle} color="danger" className='ms-4 btnCloseModal'>
                            X
                        </Button>
                        : <></>
                }

            </ModalHeader>
            <ModalBody>
                {children}
            </ModalBody>
            {btnAction
                ?
                <ModalHeader className='d-flex align-items-center justify-content-end'>
                    {btnAction && <Button color={btnActionColor} onClick={onClickBtnAction} className={"btnActionModal"}>{btnAction}</Button>}
                </ModalHeader>
                : <></>}
        </Modal>
    )

}